export function compressionPlan(bytes: number, seconds?: number, limit?: number | null) {
  if (!(seconds && seconds > 0 && limit && limit > 0)) return null;
  const totalMbps = limit * .92 * 8 / seconds / 1000000;
  const videoMbps = Math.max(0, totalMbps - .16);
  return { reductionPercent: Math.max(0, (1 - limit / bytes) * 100), totalMbps, videoMbps, audioKbps: 160,
    recommendation: videoMbps >= 3 ? '권장: 1080p 유지 가능' : videoMbps >= 1.5 ? '권장: 720p로 낮추면 화질이 덜 깨져요' : '길이를 줄이거나, 요강이 허용하면 곡별로 나눠 올리세요',
    trimSeconds: bytes > limit ? seconds * (1 - limit / bytes) : 0 };
}
export const CAPTURE_PROFILES = [
  { id:'1080-hevc',label:'1080p30 고효율',mbPerMinute:60 },{ id:'1080-h264',label:'1080p30 높은 호환성',mbPerMinute:130 },
  { id:'4k-hevc',label:'4K30 고효율',mbPerMinute:170 },{ id:'4k-h264',label:'4K30 높은 호환성',mbPerMinute:350 },
];
export function captureEstimate(minutes: number, mbPerMinute: number, limit?: number | null) { const bytes = minutes * mbPerMinute * 1000000; return { bytes, fits: limit == null ? null : bytes <= limit }; }
